import { render, staticRenderFns } from "./NsProductCard.vue?vue&type=template&id=e46a6c0c&"
import script from "./NsProductCard.vue?vue&type=script&lang=js&"
export * from "./NsProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e46a6c0c')) {
      api.createRecord('e46a6c0c', component.options)
    } else {
      api.reload('e46a6c0c', component.options)
    }
    module.hot.accept("./NsProductCard.vue?vue&type=template&id=e46a6c0c&", function () {
      api.rerender('e46a6c0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/product-components/components/NsProductCard.vue"
export default component.exports